<template>
  <div>
      <Header></Header>
      <router-view></router-view>
      <Footer></Footer>
  </div>
</template>

<script>
import Header from "../../components/header/index.vue"
import Footer from "../../components/footer/index.vue"
export default {
  data(){
      return {
      }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style scoped>

</style>
